class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.$announcements = this.querySelectorAll('.announcement-bar__item');
    this.count = this.$announcements.length;
    this.speed = this.hasAttribute('data-speed') ? this.getAttribute('data-speed') : 3000;
    this.activeClass = 'js-announcment-bar-item-active';
    this.$pause = this.querySelector('.announcement-bar__pause');
    this.$direction = this.querySelectorAll('.announcement-bar__direction');
    this.paused = false;
    this.interval;

    this.speed = 5000;
    this.addEventListener('mouseenter', this.pause.bind(this));
    this.addEventListener('mouseleave', this.start.bind(this));

    this.init();
    document.addEventListener('touchstart', this.init.bind(this), {once: true});
    addEventListener('mousemove', this.init.bind(this), {once: true});

    this.$pause.addEventListener('click', this.onPause.bind(this));

    this.$direction.forEach( $item => {
      $item.addEventListener('click', this.onDirectionClick.bind(this));
    });

    this.addEventListener('focusin', function(e){
      if( e.target !== this.$pause ){
        this.pauseSlider();
      }
    });

    this.addEventListener('keydown', function( e ){
      const $current = this.querySelector(`.${this.activeClass}`);

      let $next = false;
      if( e.key === "ArrowRight" ){
        $next = $current.nextSibling ? $current.nextSibling : this.$announcements[0]; 
      }else if( e.key === "ArrowLeft" ){
        $next = $current.previousSibling ? $current.previousSibling : this.$announcements[this.count - 1]; 
      }

      if( $next ){      
        $current.classList.remove(this.activeClass);
        $next.classList.add(this.activeClass);
        this.setTabbableItems($next.getAttribute('rel'));
        this.announceSlideChange(parseInt($next.getAttribute('rel')) + 1, this.count, "");
        this.interval = 0;
      }
    });
  }

  init() {
    this.setTabbableItems( 0 );
    this.start();
  }

  onDirectionClick( e ){
    const $elm = e.currentTarget; 
    const direction = $elm.getAttribute('data-dir');
    const $current = this.querySelector(`.${this.activeClass}`);

    let $next = false;
    if( direction === "next" ){
      $next = $current.nextSibling ? $current.nextSibling : this.$announcements[0]; 
    }else{
      $next = $current.previousSibling ? $current.previousSibling : this.$announcements[this.count - 1]; 
    }

    $current.classList.remove(this.activeClass);
    $next.classList.add(this.activeClass);
    this.setTabbableItems($next.getAttribute('rel'));
    this.announceSlideChange(parseInt($next.getAttribute('rel')) + 1, this.count, "");
    this.interval = 0;
  }  

  onPause(){
    if( this.paused ){
      this.playSlider();
    }else{      
      this.pauseSlider();
    }
  }

  pauseSlider() {
    this.$pause.setAttribute('aria-pressed', true);
    this.paused = true;
    this.pause();    
  }

  playSlider() {
    this.$pause.setAttribute('aria-pressed', false);
    this.paused = false;
    this.start();
  }

  setTabbableItems( currentSlideIndex ){
    this.$announcements.forEach( ( $item, index ) => {
      const $tabItems = $item.querySelectorAll('a, button');

      if( currentSlideIndex == index ){
        if( $item.querySelector('a, button') ){
          $item.setAttribute('tabindex', -1);
          $item.setAttribute('aria-hidden', true);
        }else{
          $item.setAttribute('tabindex', 0);
          $item.setAttribute('aria-hidden', false);
        }
      }else{
        $item.setAttribute('tabindex', -1);
        $item.setAttribute('aria-hidden', true);
      }

      $tabItems.forEach( $tabitem => {
        if( currentSlideIndex == index ){
          $tabitem.setAttribute('tabindex', 0);
          $tabitem.setAttribute('aria-hidden', false);
        }else{
          $tabitem.setAttribute('tabindex', -1);
          $tabitem.setAttribute('aria-hidden', true);
        }
      });
    });
  }

  announceSlideChange(index, total, label) {
    const status = this.querySelector('.slider-status');
    status.innerText = `Slide ${index} of ${total}${label ? ':' + label : "" }`;
  }

  pause() {
    clearInterval(this.interval);
    this.interval = false;
  }

  start() {
    if( this.paused ) return; 

    if( this.interval ) return;

    const self = this;
    this.interval = setInterval(function(){
      const $current = self.querySelector(`.${self.activeClass}`);
      const $next = $current.nextSibling ? $current.nextSibling : self.$announcements[0]; 
      $current.classList.remove(self.activeClass);
      $next.classList.add(self.activeClass);
      self.setTabbableItems($next.getAttribute('rel'));
    }, this.speed);
  }
}

customElements.define('announcement-bar', AnnouncementBar);